import React from 'react'

const PrivacyPolicy = () => {
  return (
    <div className='container py-4'>
      <div className='bg-light p-4 rounded shadow-sm'>
        {' '}
        <h1 className='font-bold mb-4'>Privacy Policy</h1>
        <p>
          We value your privacy. This policy outlines how we collect, use, and
          protect your data.
        </p>
        <h2 className='mt-4'>Information We Collect</h2>
        <ul className='list-disc ml-6 my-4'>
          <li>Personal information: name, email, phone number</li>
          <li>Payment and transaction data</li>
          <li>Usage data and cookies</li>
        </ul>
        <h2 className='mt-4'>How We Use Your Data</h2>
        <p>
          We use your data to process payments, improve our services, and
          communicate with you.
        </p>
        <h2 className='mt-4'>Data Protection</h2>
        <p>
          We implement secure protocols and encryption to protect your data. We
          do not share your data with third parties unless required by law.
        </p>
        <p className='mt-4'>
          For concerns or requests related to your data, email
          info@teslabird.com .
        </p>
      </div>
    </div>
  )
}

export default PrivacyPolicy
